import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const ChangePasswordContent = lazy(() => import('./ChangePasswordContent'));



const ChangePassword = () => {
    return (  
        <Suspense fallback={<DefaultLoader />}>
            <ChangePasswordContent />
        </Suspense>
    );
}

export default ChangePassword;
